var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67318 2.75638C5.67282 3.46362 5.39153 4.14176 4.89119 4.64161C4.39084 5.14145 3.71242 5.42207 3.00518 5.42171C2.29793 5.42136 1.6198 5.14007 1.11995 4.63972C0.620103 4.13937 0.33949 3.46096 0.339844 2.75371C0.340198 2.04647 0.621488 1.36833 1.12184 0.868485C1.62218 0.368638 2.3006 0.0880256 3.00784 0.0883792C3.71509 0.0887329 4.39322 0.370023 4.89307 0.870371C5.39292 1.37072 5.67353 2.04914 5.67318 2.75638ZM5.75318 7.39638H0.419844V24.0897H5.75318V7.39638ZM14.1798 7.39638H8.87318V24.0897H14.1265V15.3297C14.1265 10.4497 20.4865 9.99638 20.4865 15.3297V24.0897H25.7532V13.5164C25.7532 5.28971 16.3398 5.59638 14.1265 9.63638L14.1798 7.39638Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlack);
export default __webpack_public_path__ + "static/media/linkedinBlack.8a410c63c574a2d839ac2011067a27f6.svg";
export { ForwardRef as ReactComponent };